export default __webpack_public_path__ + "static/media/stickerb.f851986f.png";